// These identify Termly to the IAB. Both sides of the TCF chunk boundary need
// them: the lazily-loaded CmpApi reports them in every response, and the error
// responder in utils/tcf-gvl has to report them when that chunk never arrives.
export const CMP_ID = 412
export const CMP_VERSION = 1
